export default {
    LIST: 'specialist.list',
    API: {
        /** GET */
        LIST: 'specialist',
        /** GET */
        SHOW: 'specialist/{specialistId}',
        /** POST */
        EXPORT_PASSWORDS: 'specialist/passwords/export',
        /** POST */
        RESET_PASSWORD: 'specialist/{specialistId}/password/reset',
        /** PUT */
        UPDATE: 'specialist/{specialistId}',
        /** POST */
        STORE: 'specialist',
        /** DELETE */
        DELETE: 'specialist/{specialistId}'
    }
};
